export const isDetached = (parent, node) =>
  node != null && node.parentNode !== parent;

/* Google Translate and similar extensions replace React-owned text nodes, so React's next
 * removeChild/insertBefore throws NotFoundError and unmounts the app (facebook/react#11538). */
export const installDomGuard = (nodePrototype) => {
  const { removeChild, insertBefore } = nodePrototype;

  // eslint-disable-next-line no-param-reassign -- installing the guard is the effect
  nodePrototype.removeChild = function guardedRemoveChild(child) {
    return isDetached(this, child)
      ? child
      : Reflect.apply(removeChild, this, [child]);
  };

  // eslint-disable-next-line no-param-reassign -- installing the guard is the effect
  nodePrototype.insertBefore = function guardedInsertBefore(node, reference) {
    return isDetached(this, reference)
      ? node
      : Reflect.apply(insertBefore, this, [node, reference]);
  };
};
